// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Requirements_requirementsSection__VOfzX {
  background-color: transparent;
  font-family: system-ui, -apple-system, sans-serif;
  padding: 0px 40px;
}
@media (max-width: 767px) {
  .Requirements_requirementsSection__VOfzX {
    padding: 0px 20px;
  }
}

.Requirements_requirementsContainer__QPU2i {
  background-color: #F7F5F1;
  max-width: 1240px;
  width: 100%;
  padding: 44px 56px;
  border-radius: 24px;
  box-shadow: 0 12px 32px rgba(16, 24, 20, 0.03);
  margin: 0 auto;
}
@media (max-width: 1080px) {
  .Requirements_requirementsContainer__QPU2i {
    padding: 44px 25px;
  }
}

.Requirements_requirementsHeader__K9-54 {
  display: grid;
  grid-template-columns: minmax(290px, 1.9fr) minmax(360px, 2fr);
  row-gap: 16px;
  column-gap: clamp(36px, 6vw, 78px);
  align-items: end;
  margin-bottom: 36px;
}
@media (max-width: 1080px) {
  .Requirements_requirementsHeader__K9-54 {
    grid-template-columns: 1fr;
    gap: 25px;
  }
}

.Requirements_requirementsTitleGroup__yqCOL {
  flex: 1 1;
  max-width: 500px;
}

.Requirements_requirementsBadge__NtkI8 {
  display: inline-block;
  font-size: 12px;
  letter-spacing: 1.5px;
  font-weight: 800;
  color: #7ea088;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.Requirements_requirementsTitle__32WS8 {
  font-size: 42px !important;
  line-height: 1.15;
  font-weight: 700;
  color: #111111;
  margin: 0;
  letter-spacing: -0.5px;
}
@media (max-width: 767px) {
  .Requirements_requirementsTitle__32WS8 {
    font-size: 36px !important;
  }
}
@media (min-width: 992px) {
  .Requirements_requirementsTitle__32WS8 {
    font-size: 38px;
  }
}

.Requirements_requirementsIntro__hE4MQ {
  flex: 1 1;
  font-size: 17px;
  line-height: 1.6;
  color: #5F726B;
  margin: 0;
  padding-top: 32px;
}
@media (max-width: 767px) {
  .Requirements_requirementsIntro__hE4MQ {
    padding-top: 0;
  }
}

.Requirements_requirementsGrid__ZLxOs {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}
@media (min-width: 600px) {
  .Requirements_requirementsGrid__ZLxOs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 992px) {
  .Requirements_requirementsGrid__ZLxOs {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.Requirements_requirementsFooter__gDCEh {
  margin-top: 22px;
}

.Requirements_requirementsNotice__zfEvD {
  border: 1px solid rgba(0, 0, 0, 0.04);
  padding: 18px 20px;
  border-radius: 22px;
  background: rgba(247, 245, 241, 0.62);
  font-size: 15.5px;
  line-height: 1.68;
  color: #5F726B;
  margin: 0;
}
.Requirements_requirementsNotice__zfEvD strong {
  color: #13231D;
  font-weight: 700;
}

.Requirements_requirementsCard__IovGw {
  border: 1px solid rgba(19, 35, 29, 0.0784313725);
  padding: 26px 24px;
  border-radius: 24px;
  display: grid;
  gap: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.Requirements_requirementsCard__IovGw:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
}

.Requirements_cardTitle__85xcd {
  margin: 0 0 2px;
  font-size: 22px;
  line-height: 1.2;
  letter-spacing: -0.03em;
  font-weight: 700;
  color: #13231D;
}

.Requirements_cardDescription__WMloV {
  margin: 0;
  font-size: 15.5px;
  line-height: 1.72;
  color: #5F726B;
}`, "",{"version":3,"sources":["webpack://./src/components/Landing/Requirements/Requirements.module.scss"],"names":[],"mappings":"AAQA;EACI,6BAAA;EACA,iDAAA;EACA,iBAAA;AAPJ;AASI;EALJ;IAMQ,iBAAA;EANN;AACF;;AASA;EACI,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAlBY;EAmBZ,8CAAA;EACA,cAAA;AANJ;AAQI;EATJ;IAUQ,kBAAA;EALN;AACF;;AAQA;EACI,aAAA;EACA,8DAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;AALJ;AAOI;EARJ;IASQ,0BAAA;IACA,SAAA;EAJN;AACF;;AAOA;EACI,SAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cApDW;EAqDX,yBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA/DQ;EAgER,SAAA;EACA,sBAAA;AAJJ;AAMI;EARJ;IASQ,0BAAA;EAHN;AACF;AAKI;EAZJ;IAaQ,eAAA;EAFN;AACF;;AAKA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AAFJ;AAII;EARJ;IASQ,cAAA;EADN;AACF;;AAIA;EACI,aAAA;EACA,0BAAA;EACA,SAAA;AADJ;AAGI;EALJ;IAMQ,gDAAA;EAAN;AACF;AAEI;EATJ;IAUQ,gDAAA;EACN;AACF;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AACJ;AACI;EACI,cAAA;EACA,gBAAA;AACR;;AAGA;EACI,gDAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,qDAAA;AAAJ;AAEI;EACI,2BAAA;EACA,0CAAA;AAAR;;AAIA;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AADJ;;AAIA;EACI,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AADJ","sourcesContent":["$bg-main: #fcfbfa;\n$bg-card: #f9f7f4;\n$text-dark: #111111;\n$text-muted: #555555;\n$color-accent: #7ea088;\n$border-radius: 24px;\n$border-radius-card: 20px;\n\n.requirementsSection {\n    background-color: transparent;\n    font-family: system-ui, -apple-system, sans-serif;\n    padding: 0px 40px;\n\n    @media (max-width: 767px) {\n        padding: 0px 20px;\n    }\n}\n\n.requirementsContainer {\n    background-color: #F7F5F1;\n    max-width: 1240px;\n    width: 100%;\n    padding: 44px 56px;\n    border-radius: $border-radius;\n    box-shadow: 0 12px 32px rgba(16, 24, 20, .03);\n    margin: 0 auto;\n\n    @media (max-width: 1080px) {\n        padding: 44px 25px;\n    }\n}\n\n.requirementsHeader {\n    display: grid;\n    grid-template-columns: minmax(290px, 1.9fr) minmax(360px, 2fr);\n    row-gap: 16px;\n    column-gap: clamp(36px, 6vw, 78px);\n    align-items: end;\n    margin-bottom: 36px;\n\n    @media (max-width: 1080px) {\n        grid-template-columns: 1fr;\n        gap: 25px;\n    }\n}\n\n.requirementsTitleGroup {\n    flex: 1;\n    max-width: 500px;\n}\n\n.requirementsBadge {\n    display: inline-block;\n    font-size: 12px;\n    letter-spacing: 1.5px;\n    font-weight: 800;\n    color: $color-accent;\n    text-transform: uppercase;\n    margin-bottom: 16px;\n}\n\n.requirementsTitle {\n    font-size: 42px !important;\n    line-height: 1.15;\n    font-weight: 700;\n    color: $text-dark;\n    margin: 0;\n    letter-spacing: -0.5px;\n\n    @media (max-width: 767px) {\n        font-size: 36px !important;\n    }\n\n    @media (min-width: 992px) {\n        font-size: 38px;\n    }\n}\n\n.requirementsIntro {\n    flex: 1;\n    font-size: 17px;\n    line-height: 1.6;\n    color: #5F726B;\n    margin: 0;\n    padding-top: 32px;\n\n    @media (max-width: 767px) {\n        padding-top: 0;\n    }\n}\n\n.requirementsGrid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 20px;\n\n    @media (min-width: 600px) {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    @media (min-width: 992px) {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n.requirementsFooter {\n    margin-top: 22px;\n}\n\n.requirementsNotice {\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    padding: 18px 20px;\n    border-radius: 22px;\n    background: rgba(247, 245, 241, 0.62);\n    font-size: 15.5px;\n    line-height: 1.68;\n    color: #5F726B;\n    margin: 0;\n\n    strong {\n        color: #13231D;\n        font-weight: 700;\n    }\n}\n\n.requirementsCard {\n    border: 1px solid #13231d14;\n    padding: 26px 24px;\n    border-radius: 24px;\n    display: grid;\n    gap: 10px;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);\n    }\n}\n\n.cardTitle {\n    margin: 0 0 2px;\n    font-size: 22px;\n    line-height: 1.2;\n    letter-spacing: -.03em;\n    font-weight: 700;\n    color: #13231D;\n}\n\n.cardDescription {\n    margin: 0;\n    font-size: 15.5px;\n    line-height: 1.72;\n    color: #5F726B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requirementsSection": `Requirements_requirementsSection__VOfzX`,
	"requirementsContainer": `Requirements_requirementsContainer__QPU2i`,
	"requirementsHeader": `Requirements_requirementsHeader__K9-54`,
	"requirementsTitleGroup": `Requirements_requirementsTitleGroup__yqCOL`,
	"requirementsBadge": `Requirements_requirementsBadge__NtkI8`,
	"requirementsTitle": `Requirements_requirementsTitle__32WS8`,
	"requirementsIntro": `Requirements_requirementsIntro__hE4MQ`,
	"requirementsGrid": `Requirements_requirementsGrid__ZLxOs`,
	"requirementsFooter": `Requirements_requirementsFooter__gDCEh`,
	"requirementsNotice": `Requirements_requirementsNotice__zfEvD`,
	"requirementsCard": `Requirements_requirementsCard__IovGw`,
	"cardTitle": `Requirements_cardTitle__85xcd`,
	"cardDescription": `Requirements_cardDescription__WMloV`
};
export default ___CSS_LOADER_EXPORT___;
